import React, { Component } from 'react'
import Scroller from 'client/shared/blocks/scroller'
import FloatingAction from 'client/shared/blocks/floating-action'
import DeeplinkButton from 'client/shared/blocks/deeplink-button'
import { ShelfProps } from 'client/shared/types/shelf'

type Props = {
  shelf: ShelfProps
  fixed: boolean
}

type State = {
  fixed: boolean
}

class ShelfDeeplinkButton extends Component<Props, State> {
  static defaultProps = {
    fixed: false,
  }

  state = {
    fixed: false,
  }

  fix = () => {
    this.setState({ fixed: true })
  }

  unfix = () => {
    this.setState({ fixed: false })
  }

  isFixed() {
    const { fixed } = this.props

    return fixed || this.state.fixed
  }

  render() {
    const { fixed } = this.props

    return fixed ? this.renderActionButton() : this.renderFloatingActionButton()
  }

  renderActionButton = () => {
    const { shelf } = this.props

    const deepButton = <DeeplinkButton resourceType="shelf" uuid={shelf.uuid} />

    return (
      <div>
        {deepButton}
        {this.isFixed() && <FloatingAction>{deepButton}</FloatingAction>}
      </div>
    )
  }

  renderFloatingActionButton = () => {
    return (
      <Scroller onReach={{ top: this.fix, bottom: this.unfix }}>
        {this.renderActionButton()}
      </Scroller>
    )
  }
}

export default ShelfDeeplinkButton
